module.exports = __webpack_public_path__ + "static/media/avatar-clinician.5cee773f.png";